import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { BookOpen, Mail, Phone, UserPlus, Key, CheckCircle, PenTool, Calculator, Globe } from 'lucide-react'

export default function SignupInfo() {
  const navigate = useNavigate()
  const [inviteCode, setInviteCode] = useState('')

  const handleCodeSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (inviteCode.trim()) {
      // Navigate to signup page with code using React Router
      navigate(`/auth/external-signup?code=${encodeURIComponent(inviteCode.trim())}`)
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative overflow-hidden animate-fade-in">
      {/* Subtle school-themed background icons - same as login page */}
      <div className="absolute inset-0 pointer-events-none">
        {/* Top left area */}
        <BookOpen className="absolute top-16 left-16 w-16 h-16 text-gray-300/60 rotate-12 animate-float-slow" />
        <PenTool className="absolute top-32 left-32 w-12 h-12 text-gray-400/50 -rotate-6 animate-fall-gentle" />
        <Calculator className="absolute top-24 left-64 w-14 h-14 text-gray-300/60 rotate-45 animate-float-medium" />

        {/* Top right area */}
        <UserPlus className="absolute top-20 right-20 w-20 h-20 text-gray-300/70 -rotate-12 animate-fall-slow" />
        <Globe className="absolute top-40 right-32 w-16 h-16 text-gray-400/60 rotate-30 animate-float-gentle" />
        <Mail className="absolute top-60 right-16 w-12 h-12 text-gray-400/50 rotate-15 animate-fall-medium" />

        {/* Bottom left area */}
        <Key className="absolute bottom-32 left-20 w-18 h-18 text-gray-300/60 rotate-6 animate-float-slow" />
        <Phone className="absolute bottom-16 left-40 w-14 h-14 text-gray-400/50 -rotate-20 animate-fall-gentle" />

        {/* Bottom right area */}
        <CheckCircle className="absolute bottom-28 right-28 w-16 h-16 text-gray-300/60 -rotate-30 animate-float-medium" />
        <UserPlus className="absolute bottom-12 right-12 w-12 h-12 text-gray-400/50 rotate-45 animate-fall-slow" />

        {/* Center scattered - very subtle */}
        <Calculator className="absolute top-1/3 left-8 w-10 h-10 text-gray-400/40 rotate-12 animate-float-gentle" />
        <Globe className="absolute bottom-1/3 right-8 w-12 h-12 text-gray-400/40 -rotate-12 animate-fall-medium" />
        <Key className="absolute top-2/3 left-12 w-8 h-8 text-gray-400/40 rotate-30 animate-float-slow" />
        <CheckCircle className="absolute bottom-2/3 right-6 w-10 h-10 text-gray-400/40 -rotate-15 animate-fall-gentle" />
      </div>

      <div className="max-w-md w-full space-y-8 relative z-10">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="text-center mb-8">
            <div className="mb-6 flex justify-center">
              <img
                src="/flexwise-logo-with-tagline.png"
                alt="FlexWise - Flexible Tools for Smart Schools"
                className="w-auto"
                style={{ height: '114px' }}
              />
            </div>
            
          </div>

            <div className="space-y-6">
              <div className="text-center">
                <Key className="w-12 h-12 text-blue-600 mx-auto mb-4" />
                <p className="text-sm text-gray-600">
                  Geben Sie den Einladungscode ein, den Sie von Ihrer Schule oder Organisation erhalten haben.
                </p>
              </div>

              <form onSubmit={handleCodeSubmit} className="space-y-4">
                <div>
                  <label htmlFor="inviteCode" className="block text-sm font-medium text-gray-700 mb-2">
                    Einladungscode
                  </label>
                  <input
                    id="inviteCode"
                    type="text"
                    value={inviteCode}
                    onChange={(e) => setInviteCode(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center font-mono"
                    placeholder="z.B. ABC123DEF456"
                    required
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Der Code besteht normalerweise aus Buchstaben und Zahlen
                  </p>
                </div>

                <div className="space-y-3">
                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors font-medium"
                  >
                    Code validieren und fortfahren
                  </button>

                  <Link
                    to="/login"
                    className="w-full block text-center py-2 px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    Zurück zur Anmeldung
                  </Link>
                </div>
              </form>
            </div>
        </div>

      </div>
    </div>
  )
}
